module.exports = __webpack_public_path__ + "static/media/iconSondageActive.2bad1e13.svg";